import { jsxs as C, jsx as t } from "react/jsx-runtime";
function e(i) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#clip0_134156_86)", children: /* @__PURE__ */ t("path", { d: "M12.6187 1.57503C12.9937 1.41878 13.4219 1.50628 13.7094 1.79066L15.7094 3.79066C15.8969 3.97816 16.0031 4.23128 16.0031 4.49691C16.0031 4.76253 15.8969 5.01566 15.7094 5.20316L13.7094 7.20316C13.4219 7.49066 12.9937 7.57503 12.6187 7.41878C12.2437 7.26253 12 6.90003 12 6.49378V5.50003H10.8281C10.5625 5.50003 10.3094 5.60628 10.1219 5.79378L7.41563 8.50003L10.1219 11.2063C10.3094 11.3938 10.5625 11.5 10.8281 11.5H12V10.5C12 10.0969 12.2437 9.73128 12.6187 9.57503C12.9937 9.41878 13.4219 9.50628 13.7094 9.79066L15.7094 11.7907C15.8969 11.9782 16.0031 12.2313 16.0031 12.4969C16.0031 12.7625 15.8969 13.0157 15.7094 13.2032L13.7094 15.2032C13.4219 15.4907 12.9937 15.575 12.6187 15.4188C12.2437 15.2625 12 14.9 12 14.4938V13.5H10.8281C10.0312 13.5 9.26875 13.1844 8.70625 12.6219L5.58437 9.50003H1C0.446875 9.50003 0 9.05316 0 8.50003C0 7.94691 0.446875 7.50003 1 7.50003H5.58437L8.70625 4.37816C9.26875 3.81566 10.0312 3.50003 10.8281 3.50003H12V2.50003C12 2.09691 12.2437 1.73128 12.6187 1.57503Z" }) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_134156_86", children: /* @__PURE__ */ t("rect", { width: "16", height: "16", transform: "translate(0 0.5)" }) }) })
      ]
    }
  );
}
export {
  e as SplitTestIcon
};
